import { apiClient } from '../lib/api-client';
import type { AdminDashboardStatsDto } from '../types/admin-api';

export const dashboardService = {
  getStats: async () => {
    const response = await apiClient.get<AdminDashboardStatsDto>('/dashboard');
    return response.data;
  },
};
